import { render, staticRenderFns } from "./HandleTokenAuth.vue?vue&type=template&id=1cdf50ae&"
import script from "./HandleTokenAuth.vue?vue&type=script&lang=js&"
export * from "./HandleTokenAuth.vue?vue&type=script&lang=js&"
import style0 from "./HandleTokenAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports